import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { filtersOptions } from '../filter-sort-config';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-miti-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
    ],
    templateUrl: './miti-dialog.component.html',
})
export class MitiDialogComponent {
    showStepper = false;
    currentSection = 1;
    currentStep = 1;
    filters: any = filtersOptions;
    searchForm: FormGroup;
    selectedLanguage: any;
    err: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<MitiDialogComponent>,
        private fb: FormBuilder
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.searchForm = this.fb.group({
            operationDuration: [''],
            industry: [[]],
            fundingAmount: [''],
        });
    }

    ngOnInit() {
        this.filters = this.filters.map((filter) => ({
            ...filter,
            subFilters: filter.subFilters.filter(
                (subFilter) => subFilter.label !== 'All'
            ),
        }));
    }

    getCurrentStepFilters() {
        switch (this.currentStep) {
            case 1:
                return this.filters[0].subFilters; // Business Operation Years
            case 2:
                return this.filters[1].subFilters; // Agency
            case 3:
                return this.filters[2].subFilters; // Industry
            case 4:
                return this.filters[3].subFilters; // Funding Amount
            default:
                return [];
        }
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    openStepper(): void {
        this.currentSection = 2;
    }

    nextStep(): void {
        this.err = false;
        if (this.currentStep < 3) {
            const currFilter = this.getCurrentStepFilters();

            if (this.currentStep === 1) {
                const operationDuration =
                    this.searchForm.get('operationDuration').value;
                if (!operationDuration) {
                    this.err = true;
                    return;
                }
            } else if (this.currentStep === 2) {
                const industries = this.searchForm.get('industry').value;
                if (!industries || industries.length === 0) {
                    this.err = true;
                    return;
                }
            }
            this.currentStep++;
        }
    }

    prevStep(): void {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    onIndustryChange(value: string) {
        const industryControl = this.searchForm.get('industry');
        const selectedIndustries: string[] = industryControl?.value || [];

        if (selectedIndustries.includes(value)) {
            // Remove from selected if already present
            industryControl?.setValue(
                selectedIndustries.filter((item) => item !== value)
            );
        } else {
            // Add to selected if not present
            industryControl?.setValue([...selectedIndustries, value]);
        }
    }

    submitForm() {
        const fAmount = this.searchForm.get('fundingAmount').value;
        if (!fAmount) {
            this.err = true;
            return;
        }
        this.dialogRef.close(this.searchForm.value);
    }
}
